<template>
    <div>
         <v-tabs :value="activeTab" background-color="transparent" class="denser-tabs" slider-size="4">
            <v-tab
                v-for="language in languages"
                :class="isTabError(language.code) ? 'error--text' : ''"
                :key="language.code"
                @click="$emit('selectLocaleCode', language.code)"
            >
                <span class="caption font-weight-medium">
                    {{ formatLanguageLabel({name:language.code.substr(0, 2), code: language.code}) }}
                </span>
            </v-tab>
        </v-tabs>

        <v-text-field
            :value="subject"
            outlined
            :disabled="!canEditTemplate"
            :error-messages="subjectError"
            :hide-details="!subjectError"
            class="pt-0"
            @input="onSubjectInput"
        ></v-text-field>
        <rich-text-editor
            ref="richTextEditor"
            toolbar="#email-automation-content-toolbar"
            :content="content"
            :disabled="!canEditTemplate"
            :error-message="contentError"
            @input="onContentInput"
        />
        <div class="mt-5" v-if="files.length">
            <attachments-list
                :files="files"
                :can-delete="canEditTemplate"
                @download="download($event)"
                @delete_file="$emit('deleteFile', $event)"
            />
        </div>
    </div>
</template>

<script>
import AppModule from "../../../store/modules/app";
import AccountModule from "../../../store/modules/account";
import { computed } from "@vue/composition-api";
import { $t } from "@/i18n";
import AttachmentsList from "../../../components/AttachmentsList";
import { downloadFile } from "@/helpers/helpers";
import RichTextEditor from "../../../components/RichTextEditor/RichTextEditor";
import {formatLanguageLabel} from '../../../helpers/formatting'

export default {
    name: "EditTemplateEmail",
    methods: {formatLanguageLabel},
    components: {
        AttachmentsList,
        RichTextEditor
    },
    props: {
        selectedLocaleCode: {
            type: String,
            required: true
        },
        subject: {
            type: String,
            required: true
        },
        content: {
            type: String,
            required: true
        },
        files: {
            type: Array,
            required: true
        },
        errors: {
            type: [Object, Error],
            required: true
        },
        canEditTemplate: {
            type: Boolean,
            required: true
        },
        sentData: {
            type: Object,
            default: null
        }
    },
    setup(props, ctx) {
        const { current_account } = AccountModule();
        const { languages, fetchClassifiers } = AppModule();

        fetchClassifiers({ types: ["languages"], account_id: current_account.value.id });
        const activeTab = computed(() => languages.value.findIndex(language => language.code === props.selectedLocaleCode))

        const getSentRowErrorKey = (type, localeCode) => {
            if (!props.sentData) return
            let sentRowIndex = props.sentData.rows.findIndex(x => x.locale_code === localeCode)
            if (sentRowIndex < 0) return
            let sentRow = props.sentData.rows[sentRowIndex]

            if (sentRow.locale_code === localeCode) {
                return `${sentRowIndex}.${type}`
            }
        }

        const getSentRowError = (type, localeCode) => {
            const errorKey = getSentRowErrorKey(type, localeCode)
            if (errorKey) {
                return props.errors[errorKey]
            }
        }

        const contentError = computed({
            get: () => getSentRowError('content', props.selectedLocaleCode),
            set: () => {
                const errorKey = getSentRowErrorKey('content', props.selectedLocaleCode)
                if (errorKey) {
                    props.errors[errorKey] = null
                }
            }
        })
        const subjectError = computed({
            get: () => getSentRowError('subject', props.selectedLocaleCode),
            set: () => {
                const errorKey = getSentRowErrorKey('subject', props.selectedLocaleCode)
                if (errorKey) {
                    props.errors[errorKey] = null
                }
            }
        })

        const isTabError = (localeCode) => {
            return getSentRowError('content', localeCode) || getSentRowError('subject', localeCode)
        }

        const download = (file) => {
            downloadFile('email_automation/attachment', file)
        }

        const onSubjectInput = (e) => {
            ctx.emit('updateSubject', e);
            subjectError.value = null
        }

        const onContentInput = (e) => {
            ctx.emit('updateContent', e);
            contentError.value = null
        }

        return {
            languages,
            activeTab,
            contentError,
            subjectError,
            isTabError,
            download,
            RichTextEditor,
            onContentInput,
            onSubjectInput
        }
    }
}
</script>
